<template>
    <div>
        <div class="content-header row">
            <div class="content-header-left col-md-6 col-12 mb-2">
                <h3 class="content-header-title mb-0">Promos</h3>
                <div class="row breadcrumbs-top">
                    <div class="breadcrumb-wrapper col-12">
                        <ol class="breadcrumb">
                            <li class="breadcrumb-item"><a href="/">Home</a>
                            </li>
                            <li class="breadcrumb-item">
                                <Link :href="route('admin.products.index')">
                                    Promos
                                </Link>
                            </li>
                            <li class="breadcrumb-item active"> Add Promo
                            </li>
                        </ol>
                    </div>
                </div>
            </div>
        </div>

        <div class="content-body">
            <section class="card">
                <div class="card-body">
                    <form @submit.prevent="savePromo">
                        <div class="row">
                            <div class="col-12 col-sm-6">
                                <div class="form-group">
                                    <div class="controls">
                                        <label>Promo Name</label>
                                        <input type="text" v-model="promo.name" class="form-control"
                                               placeholder="Promo Name"
                                               required>
                                        <div v-if="promo.errors.name" class="text-danger text-small">
                                            {{ promo.errors.name }}
                                        </div>
                                    </div>
                                </div>

                                <div class="form-group">
                                    <div class="controls">
                                        <label>Description</label>
                                        <textarea
                                            v-model="promo.description"
                                            placeholder="Enter something..."
                                            rows="3"
                                            class="form-control"
                                            required
                                        ></textarea>
                                        <div v-if="promo.errors.description" class="text-danger text-small">
                                            {{ promo.errors.description }}
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="col-12 col-sm-6">
                                <div class="form-group">
                                    <div class="controls">
                                        <label class="form-label">Promo Type</label>
                                        <select v-model="promo.type" id="" class="form-control" required>
                                            <option value="" selected>Select a Promo Type</option>
                                            <option v-for="(key,promoType) in promoTypes" :value="promoType">
                                                {{ key }}
                                            </option>
                                        </select>
                                        <span v-if="promo.errors.type"
                                              class="text-danger text-small">{{ promo.errors.type }}</span>
                                    </div>
                                </div>

                                <template v-if="promo.type!== 'free_delivery'">
                                    <div class="form-group dropdown-input">
                                        <label>Discount</label>
                                        <select v-model="promo.discount_type" class="form-control">
                                            <option value="" selected>Discount Type</option>
                                            <option v-for="(key,discountType) in discountTypes" :value="discountType">
                                                {{ key }}
                                            </option>
                                        </select>
                                        <input v-model="promo.discount" placeholder="Amount off"
                                               class="form-control">
                                        <span v-if="promo.errors.discount" class="text-danger text-small">
                                            {{ promo.errors.discount }}
                                        </span>
                                        <br v-if="promo?.errors?.discount && promo?.errors?.discount_type">
                                        <span v-if="promo.errors.discount_type" class="text-danger text-small">
                                                {{ promo.errors.discount_type }}
                                            </span>
                                    </div>
                                </template>
                            </div>

                            <template v-if="promo.type!== 'first_time_orders'">
                                <div class="col-12 col-sm-12">
                                    <div class="coupon">
                                        <div class="container">
                                            <h2 class="text-center mt-2">
                                                <input type="text" class="coupon-input" placeholder="code"
                                                       v-model="promo.code" maxlength="7" autocomplete="off">
                                            </h2>
                                        </div>
                                        <span v-if="promo.errors.code"
                                              class="text-danger text-small mt-2 text-center">{{
                                                promo.errors.code
                                            }}</span>
                                        <!--                                        <button @click.prevent='generatePromoCode'-->
                                        <!--                                                class="btn btn-outline-primary glow float-right mt-2 ml-4">-->
                                        <!--                                            <i class="feather icon-loader"/>Generate-->
                                        <!--                                        </button>-->
                                    </div>
                                </div>
                            </template>

                            <div class="col-12 col-sm-6">
                                <div class="form-group">
                                    <div class="controls">
                                        <label>From</label>
                                        <input type="datetime-local" required v-model="promo.start_date"
                                               class="form-control"
                                               placeholder="Promo Start Date">
                                        <div v-if="promo.errors.start_date" class="text-danger text-small">
                                            {{ promo.errors.start_date }}
                                        </div>
                                    </div>
                                </div>

                                <div class="form-group">
                                    <div class="controls">
                                        <label class="form-label">Products</label>

                                        <div class="flex items-center space-x-2 mb-1">
                                            <input
                                                type="checkbox"
                                                id="all-products"
                                                v-model="promo.all_products"
                                                class="form-checkbox"
                                            />
                                            <label for="products-id" class="cursor-pointer">
                                                Is this promo available for all products?
                                            </label>
                                        </div>

                                        <span v-if="promo.errors.all_products" class="text-danger text-small">
                                          {{ promo.errors.all_products }}
                                        </span>
                                    </div>
                                </div>

                                <div class="form-group" v-if="!promo.all_products">
                                    <div class="controls">
                                        <label class="form-label">Choose Products</label>
                                        <div class="form-group">
                                            <v-select multiple v-model="selectedValue" @input="setSelectedProductsNew"
                                                      :options="formattedOptions">

                                                <template #option="{ $isLabel,label }">
                                                    <div v-if="$isLabel" disabled="true" class="label disabled">
                                                        {{ label }}
                                                    </div>
                                                    <div v-else>{{ label }}</div>
                                                </template>
                                            </v-select>
                                        </div>
                                        <a href="#" @click.prevent="selectAllProducts">Select All</a>
                                        <span v-if="promo.errors.products"
                                              class="text-danger text-small">{{ promo.errors.products }}</span>
                                    </div>
                                </div>

                                <div class="form-group">
                                    <div class="controls">
                                        <div class="flex items-center space-x-2 mb-1">
                                            <input
                                                type="checkbox"
                                                id="all-products"
                                                v-model="promo.apply_automatically"
                                                class="form-checkbox"
                                            />
                                            <label for="products-id" class="cursor-pointer">
                                                Do you want this Promo to apply automatically?
                                            </label>
                                        </div>

                                        <span v-if="promo.errors.apply_automatically" class="text-danger text-small">
                                          {{ promo.errors.apply_automatically }}
                                        </span>
                                    </div>
                                </div>
                                <div class="form-group">
                                    <div class="controls">
                                        <div class="flex items-center space-x-2 mb-1">
                                            <input
                                                type="checkbox"
                                                id="all-products"
                                                v-model="promo.status"
                                                class="form-checkbox"
                                            />
                                            <label for="products-id" class="cursor-pointer">
                                                Make Promo Active
                                            </label>
                                        </div>

                                        <span v-if="promo.errors.status" class="text-danger text-small">
                                          {{ promo.errors.staus }}
                                        </span>
                                    </div>
                                </div>
                            </div>

                            <div class="col-12 col-sm-6">
                                <div class="form-group">
                                    <div class="controls">
                                        <label>To</label>
                                        <input type="datetime-local" v-model="promo.end_date" class="form-control"
                                               placeholder="Promo End Date">
                                        <div v-if="promo.errors.end_date" class="text-danger text-small">
                                            {{ promo.errors.end_date }}
                                        </div>
                                    </div>
                                </div>

                                <div class="form-group">
                                    <div class="controls">
                                        <label class="form-label">Stores</label>

                                        <div class="flex items-center space-x-2 mb-1">
                                            <input
                                                type="checkbox"
                                                id="all-store"
                                                v-model="promo.all_stores"
                                                class="form-checkbox"
                                            />
                                            <label for="store-id" class="cursor-pointer">
                                                Is this promo available for all stores?
                                            </label>
                                        </div>

                                        <span v-if="promo.errors.all_stores" class="text-danger text-small">
                                          {{ promo.errors.all_stores }}
                                        </span>
                                    </div>
                                </div>

                                <div class="form-group" v-if="!promo.all_stores">
                                    <div class="controls">
                                        <label class="form-label">Stores</label>
                                        <v-select multiple v-model="selectedOptions" :options="availableStores"
                                                  label="name" :reduce="name => name.id"></v-select>
                                        <span v-if="promo.errors.stores"
                                              class="text-danger text-small">{{ promo.errors.stores }}</span>
                                    </div>
                                </div>
                            </div>

                            <div class="col-12 d-flex flex-sm-row flex-column justify-content-end mt-1">
                                <button type="submit" class="btn btn-primary glow mb-1 mb-sm-0 mr-0 mr-sm-1"
                                        :disabled="saving">
                                    Save
                                    <i class="fa fa-spinner fa-spin" v-if="saving"/>
                                </button>
                            </div>
                        </div>
                    </form>
                </div>
            </section>
        </div>
    </div>
</template>

<script>
import Layout from '@/Shared/Layout';
import {Link} from "@inertiajs/vue2";
import DeleteAlert from "../../Shared/Mixins/DeleteAlert";
import PaginationMixin from "../../Shared/Mixins/PaginationMixin";

export default {
    metaInfo: {title: 'Create Promo'},
    name: 'PromoCreate',
    mixins: [
        DeleteAlert,
    ],
    props: [
        'isEditing',
        'promoTypes',
        'discountTypes',
        'allStores',
        'allProducts',
        'promoData',
    ],
    components: {
        Link,
    },
    layout: Layout,
    data() {
        return {
            selectedValue: [],
            availableStores: [
                {
                    'name': "All Stores",
                    "id": "all",
                }
            ],
            alphabet: 'abcdefghijklmnopqrstuvwxyz',
            promo: this.$inertia.form({
                all_products: true,
                all_stores: true,
                apply_automatically: false,
                name: null,
                type: "",
                description: null,
                discount_type: "",
                code: null,
                stores: [],
                start_date: null,
                end_date: null,
                products: [],
                discount: null,
                productsDropdown: [],
                status: false
            }),
            saving: false,
            selectedOptions: [],
        }
    },
    watch: {
        selectedOptions(newVal) {
            if (newVal.includes('all')) {
                this.selectedOptions = this.availableStores
                    .filter((option) => option.id !== 'all')
                    .map((option) => option.id);
                this.promo.stores = this.selectedOptions
            } else {
                this.promo.stores = this.selectedOptions
            }
        },
    },
    methods: {
        selectAllProducts() {
            this.selectedValue = this.formattedOptions
            this.setSelectedProductsNew(this.selectedValue);
        },
        generatePromoCode() {
            this.promo.code = Array.from({length: 10}, () => this.alphabet[Math.floor(Math.random() * this.alphabet.length)]).join('').toUpperCase();
        },

        async checkForOverlappingAutomaticPromo(start_date, end_date) {
            //get overlapping promo and send alert
            const data = await axios.post(route('admin.promos.get-overlapping-promos'),
                {
                    start_date,
                    end_date,
                },
            )
            console.log(data)
            return data.data.data
        },

        setSelectedProductsNew(values) {
            let total = new Set();
            values.forEach((value) => {
                if (value.name && !value.name.toString().includes('_')) {
                    const matchingOptions = this.formattedOptions.filter((option) => {
                        return typeof option.name == "string" ? option.name.startsWith(value.name.toString() + '_') : false
                    });
                    matchingOptions.forEach(option => total.add(option.name));
                } else {
                    total.add(value.name);
                }
            })
            this.promo.products = [...total]
        },

        async savePromo() {
            this.saving = true;
            const options = {
                preserveScroll: true,
                onSuccess: () => {
                    this.saving = false
                    $('ul.navigation.navigation-main li.active').removeClass('active');
                },
                onError: () => {
                    this.saving = false;
                }
            };

            if (this.isEditing) {
                this.promo.post(route('admin.promos.update', this.promoData.id), options);
            } else {
                // if (this.promo.apply_automatically) {
                //     const promoData = await this.checkForOverlappingAutomaticPromo(this.promo.start_date, this.promo.end_date)
                //     console.log(promoData)
                //     if (promoData) {
                //         const details = {
                //             title: "Are you sure you want to create this promo?",
                //             text: `This promo would be overlapping with ${promoData.name} promo`,
                //         }
                //         await this.deleteAlert(details.title, details.text, true, "#3085d6", "#d33",  "Yes, create it!") ? this.promo.post(route('admin.promos.store'), options) : this.saving = false;
                //     } else {
                //         this.promo.post(route('admin.promos.store'), options)
                //     }
                // } else {
                    this.promo.post(route('admin.promos.store'), options);
                // }
            }
        }
    },
    mounted() {
        this.availableStores = [
            {
                "id": "all",
                "name": "All Stores",
            },
            ...this.allStores
        ];

        if (this.isEditing) {

            this.promo.name = this.promoData.name;
            this.promo.type = this.promoData.type;
            this.promo.description = this.promoData.description;
            this.promo.discount_type = this.promoData.discount_type;
            this.promo.code = this.promoData.code;
            this.promo.stores = this.promoData.stores;
            this.selectedOptions = this.promoData.stores;
            this.promo.start_date = this.promoData.start_date;
            this.promo.end_date = this.promoData.end_date;
            this.promo.discount = this.promoData.discount;
            this.promo.products = [];
            this.promoData.sizes.forEach((size) => {
                let sizeName = `${size.pivot.product_id}_${size.pivot.size_id}`;
                this.promo.products.push(sizeName);
            });
            this.selectedValue = this.formattedOptions.filter((option) => this.promo.products.includes(option.name))
            this.promo.all_products = this.promoData.all_products
            this.promo.all_stores = this.promoData.all_stores
            this.promo.apply_automatically = this.promoData.apply_automatically
            this.promo.status = this.promoData.status

        } else {
            // this.generatePromoCode();
            this.availableStores = [
                {
                    "id": "all",
                    "name": "All Stores",
                },
                ...this.allStores
            ];
        }
    },

    computed: {
        formattedOptions() {
            let formatted = []

            this.allProducts.forEach((product) => {
                let group = {label: product.name, $isLabel: true, disabled: true, name: product.id}
                let options = []

                product.sizes_promo.forEach((sizesPromo) => {
                    options.push({
                        label: `${product.name} (${sizesPromo.name})`,
                        group: product.name,
                        name: sizesPromo.pivot.product_id + '_' + sizesPromo.pivot.size_id
                    })
                })
                formatted.push(group)
                formatted = formatted.concat(options)
            })

            formatted.forEach((option, index) => {
                if (option.$isLabel === undefined && formatted[index - 1] && formatted[index - 1].$isLabel) {
                    option.$isLabel = false;
                }
            });
            return formatted
        }
    }
}
</script>

<style scoped>
.coupon {
    border: 5px dotted #bbb; /* Dotted border */
    width: 80%;
    border-radius: 15px; /* Rounded border */
    margin: 0 auto; /* Center the coupon */
    max-width: 600px;
    background-color: #f1f1f1;
}

.container {
    padding: 2px 16px;
    background-color: #f1f1f1;
}

.promo {
    background: #ccc;
    padding: 3px;
}

.expire {
    color: red;
}

.coupon-input {
    border: none;
    background-color: #f1f1f1;
    max-width: 600px;
}

.v-select .vs__dropdown-toggle {
    height: auto !important;
}

.label.disabled {
    font-weight: bold;
    pointer-events: none;
}
</style>
